module.exports = __webpack_public_path__ + "img/list.1cbb0f79.svg";